var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 237,
    viewBox: "0 0 263 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149 74.5C149 115.645 115.645 149 74.5 149C33.355 149 0 115.645 0 74.5C0 33.3548 33.355 0 74.5 0C115.645 0 149 33.3548 149 74.5Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263 74.5C263 115.645 229.421 149 188 149C146.579 149 113 115.645 113 74.5C113 33.3548 146.579 0 188 0C229.421 0 263 33.3548 263 74.5Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.936 26.6494L236.152 131.866L131.322 236.697L26.1055 131.48L130.936 26.6494Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.639 80.41L177.046 75.8174L172.453 80.41L177.046 85.004L181.639 80.41Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.233 85.0032L181.64 80.4102L177.047 85.0032L181.64 89.5962L186.233 85.0032Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.828 89.5959L186.234 85.0029L181.641 89.5959L186.234 94.1889L190.828 89.5959Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 80.41L167.859 75.8174L163.266 80.41L167.859 85.004L172.452 80.41Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.639 89.5959L177.046 85.0029L172.453 89.5959L177.046 94.1889L181.639 89.5959Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.233 94.1887L181.64 89.5957L177.047 94.1887L181.64 98.7817L186.233 94.1887Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 80.41L158.675 75.8174L154.082 80.41L158.675 85.004L163.268 80.41Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.913 28.5101L103.32 23.917L98.7266 28.5101L103.32 33.1032L107.913 28.5101Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 89.5959L167.859 85.0029L163.266 89.5959L167.859 94.1889L172.452 89.5959Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.045 94.1887L172.452 89.5957L167.859 94.1887L172.452 98.7817L177.045 94.1887Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 85.0032L154.081 80.4102L149.488 85.0032L154.081 89.5962L158.674 85.0032Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.32 33.1038L98.7268 28.5107L94.1328 33.1038L98.7268 37.6969L103.32 33.1038Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 89.5959L158.675 85.0029L154.082 89.5959L158.675 94.1889L163.268 89.5959Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.913 37.6966L103.32 33.1035L98.7266 37.6966L103.32 42.2897L107.913 37.6966Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 94.1887L163.27 89.5957L158.676 94.1887L163.27 98.7817L167.863 94.1887Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.506 42.2894L107.913 37.6963L103.32 42.2894L107.913 46.8825L112.506 42.2894Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 98.7834L167.859 94.1895L163.266 98.7834L167.859 103.376L172.452 98.7834Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 89.5959L149.488 85.0029L144.895 89.5959L149.488 94.1889L154.081 89.5959Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.727 37.6963L89.343 28.3125L84.75 32.9056L94.133 42.2894L98.727 37.6963Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 94.1887L154.081 89.5957L149.488 94.1887L154.081 98.7817L158.674 94.1887Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.32 42.2894L98.7268 37.6963L94.1328 42.2894L98.7268 46.8825L103.32 42.2894Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 103.375L163.27 98.7822L158.676 103.375L163.27 107.968L167.863 103.375Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 107.968L167.859 103.375L163.266 107.968L167.859 112.561L172.452 107.968Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M149.488 94.1887L144.895 89.5957L140.301 94.1887L144.895 98.7817L149.488 94.1887Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 112.561L163.27 107.968L158.676 112.561L163.27 117.154L167.863 112.561Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 98.7805L140.304 94.1875L135.711 98.7805L140.304 103.373L144.897 98.7805Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5415 46.8822L84.9485 42.2891L80.3555 46.8822L84.9485 51.4752L89.5415 46.8822Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 107.968L149.488 103.375L144.895 107.968L149.488 112.561L154.081 107.968Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 117.154L158.675 112.561L154.082 117.154L158.675 121.747L163.268 117.154Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 103.375L135.71 98.7822L131.117 103.375L135.71 107.968L140.303 103.375Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9487 51.4759L80.3547 46.8828L75.7617 51.4759L80.3547 56.069L84.9487 51.4759Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 107.968L140.304 103.375L135.711 107.968L140.304 112.561L144.897 107.968Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5415 56.0687L84.9485 51.4756L80.3555 56.0687L84.9485 60.6618L89.5415 56.0687Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 117.154L149.488 112.561L144.895 117.154L149.488 121.747L154.081 117.154Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 121.747L154.081 117.154L149.488 121.747L154.081 126.34L158.674 121.747Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9633 71.224L94.3704 66.6309L89.7773 71.224L94.3704 75.817L98.9633 71.224Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 80.41L103.558 75.8174L98.9648 80.41L103.558 85.004L108.151 80.41Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 85.0032L108.148 80.4102L103.555 85.0032L108.148 89.5962L112.742 85.0032Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M117.338 89.5959L112.745 85.0029L108.152 89.5959L112.745 94.1889L117.338 89.5959Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 94.1887L117.335 89.5957L112.742 94.1887L117.335 98.7817L121.928 94.1887Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 98.7834L121.929 94.1895L117.336 98.7834L121.929 103.376L126.522 98.7834Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 117.154L140.304 112.561L135.711 117.154L140.304 121.747L144.897 117.154Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6928 26.7728L61.0998 22.1797L48.8828 34.3966L53.4758 38.9897L65.6928 26.7728Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3628 65.2943L84.7698 60.7012L80.1758 65.2943L84.7698 69.8874L89.3628 65.2943Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9126 60.8802L69.3196 56.2871L64.7266 60.8802L69.3196 65.4733L73.9126 60.8802Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9487 32.9251L80.3547 28.332L75.7617 32.9251L80.3547 37.5182L84.9487 32.9251Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7758 24.096L89.1828 19.5029L84.5898 24.096L89.1828 28.6891L93.7758 24.096Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4985 30.7171L64.9055 26.124L60.3125 30.7171L64.9055 35.3102L69.4985 30.7171Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5356 22.68L72.9426 18.0869L64.7266 26.3037L69.3196 30.8968L77.5356 22.68Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.342 51.3167L98.7488 46.7236L89.4648 56.0073L94.0578 60.6004L103.342 51.3167Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 126.34L149.488 121.747L144.895 126.34L149.488 130.933L154.081 126.34Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 135.527L158.675 130.934L154.082 135.527L158.675 140.12L163.268 135.527Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 140.118L163.27 135.525L158.676 140.118L163.27 144.712L167.863 140.118Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 144.712L167.859 140.119L163.266 144.712L167.859 149.305L172.452 144.712Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M177.045 149.305L172.452 144.712L167.859 149.305L172.452 153.898L177.045 149.305Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M181.639 153.9L177.046 149.307L172.453 153.9L177.046 158.493L181.639 153.9Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 75.8157L89.7766 71.2227L85.1836 75.8157L89.7766 80.409L94.3696 75.8157Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9633 80.41L94.3704 75.8174L89.7773 80.41L94.3704 85.004L98.9633 80.41Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 89.5959L103.558 85.0029L98.9648 89.5959L103.558 94.1889L108.151 89.5959Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 94.1887L108.148 89.5957L103.555 94.1887L108.148 98.7817L112.742 94.1887Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 107.968L121.929 103.375L117.336 107.968L121.929 112.561L126.522 107.968Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 117.154L131.116 112.561L126.523 117.154L131.116 121.747L135.709 117.154Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M149.488 130.933L144.895 126.34L140.301 130.933L144.895 135.526L149.488 130.933Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 144.712L158.675 140.119L154.082 144.712L158.675 149.305L163.268 144.712Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M172.452 153.9L167.859 149.307L163.266 153.9L167.859 158.493L172.452 153.9Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M177.045 158.492L172.452 153.898L167.859 158.492L172.452 163.085L177.045 158.492Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 80.41L85.1838 75.8174L80.5898 80.41L85.1838 85.004L89.7769 80.41Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 85.0032L89.7766 80.4102L85.1836 85.0032L89.7766 89.5962L94.3696 85.0032Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 94.1887L98.9641 89.5957L94.3711 94.1887L98.9641 98.7817L103.557 94.1887Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 103.375L108.148 98.7822L103.555 103.375L108.148 107.968L112.742 103.375Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M117.334 107.969L112.741 103.376L108.148 107.969L112.741 112.562L117.334 107.969Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 112.561L117.335 107.968L112.742 112.561L117.335 117.154L121.928 112.561Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 121.747L126.523 117.154L121.93 121.747L126.523 126.34L131.117 121.747Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 130.934L135.71 126.341L131.117 130.934L135.71 135.527L140.303 130.934Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4751 48.1761L48.8821 43.583L44.2891 48.1761L48.8821 52.7692L53.4751 48.1761Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M149.488 140.118L144.895 135.525L140.301 140.118L144.895 144.712L149.488 140.118Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 153.9L158.675 149.307L154.082 153.9L158.675 158.493L163.268 153.9Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 158.492L163.27 153.898L158.676 158.492L163.27 163.085L167.863 158.492Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M177.045 167.678L172.452 163.085L167.859 167.678L172.452 172.271L177.045 167.678Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M85.186 85.0032L80.593 80.4102L76 85.0032L80.593 89.5962L85.186 85.0032Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 89.5959L85.1838 85.0029L80.5898 89.5959L85.1838 94.1889L89.7769 89.5959Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 94.1887L89.7766 89.5957L85.1836 94.1887L89.7766 98.7817L94.3696 94.1887Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 107.968L103.558 103.375L98.9648 107.968L103.558 112.561L108.151 107.968Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 126.34L121.929 121.747L117.336 126.34L121.929 130.933L126.522 126.34Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 153.9L149.488 149.307L144.895 153.9L149.488 158.493L154.081 153.9Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 158.492L154.081 153.898L149.488 158.492L154.081 163.085L158.674 158.492Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 163.084L158.675 158.491L154.082 163.084L158.675 167.677L163.268 163.084Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M167.863 167.678L163.27 163.085L158.676 167.678L163.27 172.271L167.863 167.678Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 103.375L89.7766 98.7822L85.1836 103.375L89.7766 107.968L94.3696 103.375Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M108.151 117.154L103.558 112.561L98.9648 117.154L103.558 121.747L108.151 117.154Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 130.933L117.335 126.34L112.742 130.933L117.335 135.526L121.928 130.933Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 140.118L126.523 135.525L121.93 140.118L126.523 144.712L131.117 140.118Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2875 57.3616L39.6945 52.7686L35.1016 57.3616L39.6945 61.9547L44.2875 57.3616Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 149.305L135.71 144.712L131.117 149.305L135.71 153.898L140.303 149.305Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4751 66.5482L48.8821 61.9551L44.2891 66.5482L48.8821 71.1413L53.4751 66.5482Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4594 38.0755L37.8664 33.4824L33.2734 38.0755L37.8664 42.6686L42.4594 38.0755Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 163.084L149.488 158.491L144.895 163.084L149.488 167.677L154.081 163.084Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 172.271L158.675 167.678L154.082 172.271L158.675 176.864L163.268 172.271Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 130.933L108.148 126.34L103.555 130.933L108.148 135.526L112.742 130.933Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 144.712L121.929 140.119L117.336 144.712L121.929 149.305L126.522 144.712Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6948 61.9534L35.1018 57.3604L30.5078 61.9534L35.1018 66.5465L39.6948 61.9534Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 149.305L126.523 144.712L121.93 149.305L126.523 153.898L131.117 149.305Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2875 66.5482L39.6945 61.9551L35.1016 66.5482L39.6945 71.1413L44.2875 66.5482Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2915 43.9603L62.6985 39.3672L58.1055 43.9603L62.6985 48.5534L67.2915 43.9603Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 153.9L131.116 149.307L126.523 153.9L131.116 158.493L135.709 153.9Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8813 71.1409L44.2883 66.5479L39.6953 71.1409L44.2883 75.734L48.8813 71.1409Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9141 99.4934L30.5071 104.086L35.1001 99.4934L30.5071 94.9004L25.9141 99.4934Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1008 95.458L37.5078 100.051L42.1008 104.644L46.6938 100.051L42.1008 95.458Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8667 42.6683L33.2727 38.0752L28.6797 42.6683L33.2727 47.2614L37.8667 42.6683Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1832 44.2542L71.5902 39.6611L62.6992 48.5523L67.2922 53.1454L76.1832 44.2542Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 158.492L135.71 153.898L131.117 158.492L135.71 163.085L140.303 158.492Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4751 75.7337L48.8821 71.1406L44.2891 75.7337L48.8821 80.327L53.4751 75.7337Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3203 94.8996L25.9133 99.4926L30.5063 94.8996L25.9133 90.3066L21.3203 94.8996Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6945 90.8633L42.1016 95.4563L46.6945 100.049L51.2876 95.4563L46.6945 90.8633Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4594 47.262L37.8664 42.6689L33.2734 47.262L37.8664 51.8551L42.4594 47.262Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 163.084L140.304 158.491L135.711 163.084L140.304 167.677L144.897 163.084Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 172.271L149.488 167.678L144.895 172.271L149.488 176.864L154.081 172.271Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 176.864L154.081 172.271L149.488 176.864L154.081 181.457L158.674 176.864Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M117.338 144.712L112.745 140.119L108.152 144.712L112.745 149.305L117.338 144.712Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5063 61.9534L25.9133 57.3604L21.3203 61.9534L25.9133 66.5465L30.5063 61.9534Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4526 52.0531L28.8586 47.46L24.2656 52.0531L28.8586 56.6461L33.4526 52.0531Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0922 72.6507L21.4993 68.0576L16.9062 72.6507L21.4993 77.2438L26.0922 72.6507Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6938 107.963L42.1008 103.37L37.5078 107.963L42.1008 112.556L46.6938 107.963Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 153.9L121.929 149.307L117.336 153.9L121.929 158.493L126.522 153.9Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6948 71.1409L35.1018 66.5479L30.5078 71.1409L35.1018 75.734L39.6948 71.1409Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 163.084L131.116 158.491L126.523 163.084L131.116 167.677L135.709 163.084Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2843 84.73L44.2883 75.7344L39.6953 80.327L48.6903 89.323L53.2843 84.73Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9141 90.3069L30.5071 94.8999L35.1001 90.3069L30.5071 85.7139L25.9141 90.3069Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2844 95.458L46.6914 100.051L51.2844 104.644L55.8784 100.051L51.2844 95.458Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0227 87.9209L54.4297 92.5139L59.0227 97.1069L63.6157 92.5139L59.0227 87.9209Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 167.678L135.71 163.085L131.117 167.678L135.71 172.271L140.303 167.678Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 186.049L154.081 181.456L149.488 186.049L154.081 190.642L158.674 186.049Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 140.118L98.9641 135.525L94.3711 140.118L98.9641 144.712L103.557 140.118Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M117.338 153.9L112.745 149.307L108.152 153.9L112.745 158.493L117.338 153.9Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 158.492L117.335 153.898L112.742 158.492L117.335 163.085L121.928 158.492Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1034 75.7337L30.5104 71.1406L21.6914 79.96L26.2844 84.553L35.1034 75.7337Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 163.084L121.929 158.491L117.336 163.084L121.929 167.677L126.522 163.084Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6948 80.327L35.1018 75.7344L30.5078 80.327L35.1018 84.921L39.6948 80.327Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 167.678L126.523 163.085L121.93 167.678L126.523 172.271L131.117 167.678Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 172.271L131.116 167.678L126.523 172.271L131.116 176.864L135.709 172.271Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 181.456L140.304 176.863L135.711 181.456L140.304 186.049L144.897 181.456Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M149.488 186.049L144.895 181.456L140.301 186.049L144.895 190.642L149.488 186.049Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M158.674 195.236L154.081 190.643L149.488 195.236L154.081 199.829L158.674 195.236Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9633 144.712L94.3704 140.119L89.7773 144.712L94.3704 149.305L98.9633 144.712Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 149.305L98.9641 144.712L94.3711 149.305L98.9641 153.898L103.557 149.305Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M117.338 163.084L112.745 158.491L108.152 163.084L112.745 167.677L117.338 163.084Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 176.864L126.523 172.271L121.93 176.864L126.523 181.457L131.117 176.864Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 186.049L135.71 181.456L131.117 186.049L135.71 190.642L140.303 186.049Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 190.643L140.304 186.05L135.711 190.643L140.304 195.236L144.897 190.643Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M154.081 199.827L149.488 195.234L144.895 199.827L149.488 204.421L154.081 199.827Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 149.305L89.7766 144.712L85.1836 149.305L89.7766 153.898L94.3696 149.305Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 167.678L108.148 163.085L103.555 167.678L108.148 172.271L112.742 167.678Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M126.522 181.456L121.929 176.863L117.336 181.456L121.929 186.049L126.522 181.456Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 190.643L131.116 186.05L126.523 190.643L131.116 195.236L135.709 190.643Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 195.236L135.71 190.643L131.117 195.236L135.71 199.829L140.303 195.236Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M144.897 199.827L140.304 195.234L135.711 199.827L140.304 204.421L144.897 199.827Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 153.9L85.1838 149.307L80.5898 153.9L85.1838 158.493L89.7769 153.9Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 158.492L89.7766 153.898L85.1836 158.492L89.7766 163.085L94.3696 158.492Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1482 66.0308L58.8352 53.7178L54.2422 58.3109L66.5552 70.6239L71.1482 66.0308Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9633 163.084L94.3704 158.491L89.7773 163.084L94.3704 167.677L98.9633 163.084Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7417 70.6234L71.1477 66.0303L66.5547 70.6234L71.1477 75.2165L75.7417 70.6234Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 167.678L98.9641 163.085L94.3711 167.678L98.9641 172.271L103.557 167.678Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3344 75.2161L75.7415 70.623L71.1484 75.2161L75.7415 79.809L80.3344 75.2161Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M112.742 176.864L108.148 172.271L103.555 176.864L108.148 181.457L112.742 176.864Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 195.236L126.523 190.643L121.93 195.236L126.523 199.829L131.117 195.236Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 167.678L89.7766 163.085L85.1836 167.678L89.7766 172.271L94.3696 167.678Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1508 75.2161L66.5578 70.623L61.9648 75.2161L66.5578 79.809L71.1508 75.2161Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 195.236L117.335 190.643L112.742 195.236L117.335 199.829L121.928 195.236Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 204.423L126.523 199.83L121.93 204.423L126.523 209.016L131.117 204.423Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M135.709 209.016L131.116 204.423L126.523 209.016L131.116 213.609L135.709 209.016Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M140.303 213.611L135.71 209.018L131.117 213.611L135.71 218.204L140.303 213.611Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5922 163.084L75.9992 158.491L71.4062 163.084L75.9992 167.677L80.5922 163.084Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 172.271L85.1838 167.678L80.5898 172.271L85.1838 176.864L89.7769 172.271Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5571 79.81L61.9641 75.2168L57.3711 79.81L61.9641 84.403L66.5571 79.81Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3696 176.864L89.7766 172.271L85.1836 176.864L89.7766 181.457L94.3696 176.864Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1508 84.4035L66.5578 79.8105L61.9648 84.4035L66.5578 88.9966L71.1508 84.4035Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M234.109 106.094L238.702 101.501L234.109 96.9082L229.516 101.501L234.109 106.094Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M229.515 101.5L234.108 96.9074L229.515 92.3145L224.922 96.9074L229.515 101.5Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M224.922 106.094L229.515 101.501L224.922 96.9082L220.328 101.501L224.922 106.094Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M220.331 110.687L224.924 106.094L220.331 101.501L215.738 106.094L220.331 110.687Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M224.921 96.9086L234.305 87.5246L229.712 82.9316L220.328 92.3156L224.921 96.9086Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M220.331 101.5L224.924 96.9074L220.331 92.3145L215.738 96.9074L220.331 101.5Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M215.738 87.7221L220.331 83.1291L215.738 78.5361L211.145 83.1291L215.738 87.7221Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M211.144 83.1294L215.737 78.5364L211.144 73.9434L206.551 78.5364L211.144 83.1294Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M206.55 87.7221L211.144 83.1291L206.55 78.5361L201.957 83.1291L206.55 87.7221Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M235.846 63.8715L240.439 59.2784L228.223 47.0615L223.629 51.6546L235.846 63.8715Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M197.323 87.5434L201.916 82.9504L197.323 78.3574L192.73 82.9504L197.323 87.5434Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M201.738 72.0944L206.331 67.5013L201.738 62.9082L197.145 67.5013L201.738 72.0944Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M229.695 83.1294L234.288 78.5364L229.695 73.9434L225.102 78.5364L229.695 83.1294Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M238.523 91.9575L243.116 87.3645L238.523 82.7715L233.93 87.3645L238.523 91.9575Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M231.902 67.6784L236.495 63.0853L231.902 58.4922L227.309 63.0853L231.902 67.6784Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M239.94 75.7192L244.533 71.1261L236.316 62.9092L231.723 67.5023L239.94 75.7192Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M211.304 101.521L215.898 96.928L211.304 92.335L206.711 96.928L211.304 101.521Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M214.445 51.655L219.038 47.0619L214.445 42.4688L209.852 47.0619L214.445 51.655Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M205.257 42.4693L209.851 37.8763L205.257 33.2832L200.664 37.8763L205.257 42.4693Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M196.073 51.655L200.666 47.0619L196.073 42.4688L191.48 47.0619L196.073 51.655Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M224.546 40.6393L229.139 36.0462L224.546 31.4531L219.953 36.0462L224.546 40.6393Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M200.663 37.8757L205.256 33.2826L200.663 28.6895L196.07 33.2826L200.663 37.8757Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M196.073 42.4675L200.666 37.8744L196.073 33.2812L191.48 37.8744L196.073 42.4675Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M218.659 65.4733L223.252 60.8802L218.659 56.2871L214.066 60.8802L218.659 65.4733Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M191.48 47.0632L196.073 42.4701L191.48 37.877L186.887 42.4701L191.48 47.0632Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M163.128 24.0957L158.535 28.6888L163.128 33.2818L167.721 28.6888L163.128 24.0957Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M167.163 40.2816L162.57 35.6885L157.977 40.2816L162.57 44.8747L167.163 40.2816Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M219.952 36.0456L224.545 31.4525L219.952 26.8594L215.359 31.4525L219.952 36.0456Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M218.364 74.3652L222.957 69.7721L214.066 60.8809L209.473 65.474L218.364 74.3652Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M186.886 51.655L191.48 47.0619L186.886 42.4688L182.293 47.0619L186.886 51.655Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M167.718 19.5039L163.125 24.097L167.718 28.69L172.311 24.097L167.718 19.5039Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M171.756 44.8743L167.163 40.2812L162.57 44.8743L167.163 49.4674L171.756 44.8743Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M175.436 56.4652L170.843 51.8721L166.25 56.4652L170.843 61.0583L175.436 56.4652Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M215.359 40.6393L219.952 36.0462L215.359 31.4531L210.766 36.0462L215.359 40.6393Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M200.663 28.69L205.256 24.097L200.663 19.5039L196.07 24.097L200.663 28.69Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M210.566 31.6335L215.159 27.0404L210.566 22.4473L205.973 27.0404L210.566 31.6335Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M189.968 24.2741L194.562 19.681L189.968 15.0879L185.375 19.681L189.968 24.2741Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M154.656 44.8736L159.249 40.2805L154.656 35.6875L150.062 40.2805L154.656 44.8736Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M191.48 37.8757L196.073 33.2826L191.48 28.6895L186.887 33.2826L191.48 37.8757Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 51.4655L186.886 42.4701L182.293 37.877L173.297 46.8724L177.89 51.4655Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M172.312 24.0957L167.719 28.6888L172.312 33.2818L176.905 28.6888L172.312 24.0957Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M167.163 49.4671L162.57 44.874L157.977 49.4671L162.57 54.0602L167.163 49.4671Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M186.885 33.2831L191.479 28.6901L182.66 19.8711L178.066 24.4641L186.885 33.2831Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M182.292 37.8757L186.885 33.2826L182.292 28.6895L177.699 33.2826L182.292 37.8757Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M196.589 69.3299L208.902 57.0169L204.309 52.4238L191.996 64.7368L196.589 69.3299Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M191.995 73.9225L196.588 69.3294L191.995 64.7363L187.402 69.3294L191.995 73.9225Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M187.402 78.5163L191.995 73.9232L187.402 69.3301L182.809 73.9232L187.402 78.5163Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M187.402 69.3288L191.995 64.7357L187.402 60.1426L182.809 64.7357L187.402 69.3288Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M182.812 64.7369L187.405 60.1439L182.812 55.5508L178.219 60.1439L182.812 64.7369Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M178.218 69.3288L182.812 64.7357L178.218 60.1426L173.625 64.7357L178.218 69.3288Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M103.557 186.049L98.9641 181.456L94.3711 186.049L98.9641 190.642L103.557 186.049Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M121.928 204.423L117.335 199.83L112.742 204.423L117.335 209.016L121.928 204.423Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M131.117 213.611L126.523 209.018L121.93 213.611L126.523 218.204L131.117 213.611Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M163.268 62.0374L131.116 29.8857L98.9648 62.0374L131.116 94.189L163.268 62.0374Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M154.083 62.0367L131.117 39.0713L108.152 62.0367L131.117 85.002L154.083 62.0367Z",
    fill: "#E7E7E7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M227.57 126.341L195.418 94.1895L163.266 126.341L195.418 158.493L227.57 126.341Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M218.384 126.34L195.419 103.375L172.453 126.34L195.419 149.306L218.384 126.34Z",
    fill: "#E7E7E7"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M144.894 62.0371L131.115 48.2578L117.336 62.0371L131.115 75.8164L144.894 62.0371Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M209.199 126.342L195.42 112.562L181.641 126.342L195.42 140.12L209.199 126.342Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9631 126.339L66.8112 94.1875L34.6602 126.339L66.8112 158.49L98.9631 126.339Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7787 126.34L66.8127 103.375L43.8477 126.34L66.8127 149.306L89.7787 126.34Z",
    fill: "#E7E7E7"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5903 126.34L66.8103 112.561L53.0312 126.34L66.8103 140.119L80.5903 126.34Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.003 31.0655C11.181 54.8871 11.0211 93.3489 34.6441 116.973L30.448 121.17C4.52605 95.2469 4.70205 53.0432 30.8411 26.9039C56.9801 0.764553 99.185 0.588453 125.107 26.5106L120.91 30.707C97.2861 7.08325 58.824 7.24376 35.003 31.0655Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.384 29.7278C253.371 53.7148 253.24 92.7364 229.092 116.884L233.225 121.018C259.672 94.5714 259.815 51.8361 233.545 25.5661C207.275 -0.703751 164.54 -0.560551 138.094 25.886L142.227 30.0198C166.376 5.87155 205.397 5.74085 229.384 29.7278Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNotext);
export default __webpack_public_path__ + "static/media/logo-notext.caea551ec5ceeb38ab2eb960cb676b06.svg";
export { ForwardRef as ReactComponent };